(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRotators() {
    $$('[data-rotator]').forEach((el) => {
      const items = $$('.announce__item', el);
      if (items.length < 2 || el.dataset.ready) return;
      el.dataset.ready = '1';
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, (parseInt(el.dataset.interval, 10) || 4) * 1000);
    });
  }

  function initGallery(section) {
    const track = $('[data-gallery-track]', section);
    if (!track) return;
    const counter = $('[data-gallery-counter]', section);
    const thumbs = $$('[data-gallery-thumb]', section);
    const total = track.children.length;
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        if (counter) counter.textContent = `${idx + 1} / ${total}`;
        thumbs.forEach((t, n) => t.classList.toggle('is-active', n === idx));
      });
    }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => {
      track.scrollTo({ left: track.clientWidth * Number(t.dataset.galleryThumb), behavior: reduceMotion ? 'auto' : 'smooth' });
    }));
  }

  function initOffers(section) {
    const qtyInput = $('[data-qty-input]', section);
    const radios = $$('[data-offer-qty]', section);
    const sync = () => {
      radios.forEach((r) => r.closest('.offer').classList.toggle('is-selected', r.checked));
      const checked = radios.find((r) => r.checked);
      if (checked && qtyInput) qtyInput.value = checked.value;
      // Keep the sticky Order bar in step with the chosen pack (it may have moved under <body>).
      const bar = $(`[data-sticky-buy][data-section="${section.dataset.sectionId}"]`) || $('[data-sticky-buy]', section);
      if (checked && bar) {
        const price = $('[data-sticky-price]', bar);
        const compare = $('[data-sticky-compare]', bar);
        const pack = $('[data-sticky-pack]', bar);
        if (price && checked.dataset.price) price.textContent = checked.dataset.price;
        if (compare) { compare.textContent = checked.dataset.compare || ''; compare.hidden = !checked.dataset.compare; }
        if (pack) { pack.textContent = checked.dataset.stickyText || ''; pack.hidden = !checked.dataset.stickyText; }
      }
    };
    radios.forEach((r) => r.addEventListener('change', sync));
    sync();
    $$('[data-variant-pick]', section).forEach((r) => r.addEventListener('change', () => {
      const id = $('[data-variant-id]', section);
      if (id) id.value = r.value;
      const price = $('.price__now', section);
      if (price) price.textContent = r.dataset.price;
    }));
  }

  function toast(html) {
    let t = $('.toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    requestAnimationFrame(() => t.classList.add('is-visible'));
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove('is-visible'), 3200);
  }

  async function addToCart(form) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Error');
    const cart = await fetch(`${root}cart.js`).then((r) => r.json());
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    return cart;
  }

  // Order now: empty the cart, add exactly this pack through Shopify's cart API (so the standard
  // "added to cart" event reaches the Meta / Google pixels, as on the old theme), then open checkout.
  // Emptying first means going back and tapping again never doubles the order.
  // If the cart API fails, fall back to a cart permalink, which still reaches checkout.
  async function buyNow(id, qty, code) {
    const discount = code ? `?discount=${encodeURIComponent(code)}` : '';
    try {
      await fetch(`${root}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } });
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }),
      });
      if (!res.ok) throw new Error('add failed');
      window.location.href = `${root}checkout${discount}`;
    } catch (e) {
      window.location.href = `${root}cart/${id}:${qty}${discount}`;
    }
  }

  function initBuyLinks() {
    $$('[data-buy-link]').forEach((a) => {
      if (a.dataset.ready) return;
      a.dataset.ready = '1';
      a.addEventListener('click', (e) => {
        e.preventDefault();
        a.classList.add('is-loading');
        buyNow(a.dataset.variantId, Number(a.dataset.qty) || 1, a.dataset.discount);
      });
    });
  }

  function initBuy(section) {
    const form = $('[data-product-form]', section);
    if (!form) return;
    const error = $('[data-form-error]', section);
    const skipCart = section.dataset.skipCart === 'true';

    const run = async (btn, goCheckout) => {
      btn.classList.add('is-loading');
      if (error) error.hidden = true;
      try {
        if (goCheckout && skipCart) {
          const id = $('[data-variant-id]', form).value;
          const qty = Math.max(1, parseInt($('[data-qty-input]', form)?.value, 10) || 1);
          await buyNow(id, qty, section.dataset.discount);
          return;
        }
        await addToCart(form);
        if (goCheckout) {
          window.location.href = `${root}cart`;
          return;
        }
        toast(`✓ ${section.dataset.added} <a href="${root}cart">${section.dataset.viewCart} →</a>`);
      } catch (e) {
        if (error) { error.textContent = e.message; error.hidden = false; }
        else toast(e.message);
      } finally {
        btn.classList.remove('is-loading');
      }
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      run(e.submitter || $('[data-add-to-cart]', form), false);
    });
    $$('[data-buy-now]', section).forEach((b) => b.addEventListener('click', () => run(b, true)));
  }

  function initSticky(section) {
    const bar = $('[data-sticky-buy]', section);
    const anchor = $('[data-buy-anchor]', section);
    if (!bar || !anchor) return;
    // The product section isolates its stacking context, which let later sections paint over this
    // fixed bar. Living directly under <body> keeps it on top. Click handlers were bound already.
    if (bar.parentElement !== document.body) document.body.appendChild(bar);
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('sticky-on', show);
      bar.setAttribute('aria-hidden', String(!show));
      $('button', bar).tabIndex = show ? 0 : -1;
    });
    io.observe(anchor);
  }

  function initCountdown(section) {
    $$('[data-countdown]', section).forEach((el) => {
      const h = $('[data-cd-h]', el), m = $('[data-cd-m]', el), s = $('[data-cd-s]', el);
      const fixed = el.dataset.end ? new Date(`${el.dataset.end}T23:59:59`) : null;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        let end = fixed;
        if (!end || isNaN(end) || end < now) {
          if (fixed && !isNaN(fixed) && fixed < now) { el.hidden = true; return; }
          end = new Date(now); end.setHours(23, 59, 59, 999);
        }
        const diff = Math.max(0, Math.floor((end - now) / 1000));
        const hours = Math.floor(diff / 3600);
        h.textContent = pad(hours);
        m.textContent = pad(Math.floor((diff % 3600) / 60));
        s.textContent = pad(diff % 60);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  function initDelivery(section) {
    $$('[data-delivery]', section).forEach((el) => {
      const add = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
      const fmt = new Intl.DateTimeFormat('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      const min = parseInt(el.dataset.min, 10) || 3;
      const max = parseInt(el.dataset.max, 10) || 6;
      const out = $('[data-delivery-date]', el);
      if (out) out.textContent = `${fmt.format(add(min))} – ${fmt.format(add(max))}`;
    });
  }

  function initReels() {
    const previews = $$('[data-reel-preview]');
    if (previews.length && 'IntersectionObserver' in window && !reduceMotion) {
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        const v = e.target;
        if (e.isIntersecting) { v.preload = 'metadata'; v.play().catch(() => {}); }
        else v.pause();
      }), { threshold: 0.6 });
      previews.forEach((v) => { v.muted = true; io.observe(v); });
    }

    const modal = $('#VideoModal');
    if (!modal) return;
    const body = $('[data-video-modal-body]', modal);
    const close = () => { modal.close(); };
    modal.addEventListener('close', () => { body.innerHTML = ''; });
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    $('[data-close-video]', modal).addEventListener('click', close);

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-open-video]');
      if (!btn) return;
      const tpl = document.getElementById(`Video-${btn.dataset.openVideo}`);
      if (!tpl) return;
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      modal.showModal();
      const v = $('video', body);
      if (v) { v.muted = false; v.play().catch(() => {}); }
    });
  }

  function initReviews() {
    $$('[data-reviews]').forEach((sec) => {
      const pager = $('[data-review-pager]', sec);
      if (!pager || pager.dataset.ready) return;
      pager.dataset.ready = '1';
      const list = $('[data-review-list]', sec);
      const cards = $$('[data-review-card]', sec);
      const per = parseInt(list.dataset.perPage, 10) || 4;
      const pages = Math.ceil(cards.length / per);
      let current = 1;
      const btn = (label, page, opts = {}) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'rpager__btn' + (opts.arrow ? ' rpager__btn--arrow' : '');
        b.textContent = label;
        if (opts.aria) b.setAttribute('aria-label', opts.aria);
        if (page === current && !opts.arrow) b.setAttribute('aria-current', 'page');
        b.disabled = page < 1 || page > pages;
        b.addEventListener('click', () => show(page, true));
        return b;
      };
      const show = (page, scroll) => {
        current = page;
        cards.forEach((c, i) => { c.hidden = Math.floor(i / per) + 1 !== page; });
        pager.replaceChildren(
          btn('‹', page - 1, { arrow: true, aria: 'Previous page' }),
          ...Array.from({ length: pages }, (_, i) => btn(String(i + 1), i + 1, { aria: `Page ${i + 1}` })),
          btn('›', page + 1, { arrow: true, aria: 'Next page' })
        );
        if (scroll && list.getBoundingClientRect().top < 0) {
          list.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      };
      show(1, false);
    });
  }

  // Judge.me swaps reviews in place when a page number is clicked; the browser then keeps the
  // pager in view and the visitor lands at the bottom. Bring them to the top of the new reviews instead.
  function initJudgemePaging() {
    $$('.rjm').forEach((box) => {
      if (box.dataset.pagingReady) return;
      box.dataset.pagingReady = '1';
      let pending = false;
      let timer;
      box.addEventListener('click', (e) => {
        if (e.target.closest('.jdgm-paginate__page, .jdgm-paginate a, [class*="paginat"] button')) pending = true;
      }, true);
      new MutationObserver(() => {
        if (!pending) return;
        clearTimeout(timer);
        timer = setTimeout(() => {
          pending = false;
          const header = $('.section-header');
          const offset = (header ? header.offsetHeight : 0) + 12;
          const target = $('.jdgm-rev-widg__reviews, .jdgm-rev', box) || box;
          // Jump instantly: a smooth scroll gets cancelled when content above shifts (lazy images).
          window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'auto' });
        }, 120);
      }).observe(box, { childList: true, subtree: true });
    });
  }

  function initBeforeAfter() {
    $$('[data-ba]').forEach((frame) => {
      const range = $('[data-ba-range]', frame);
      range.addEventListener('input', () => frame.style.setProperty('--pos', `${range.value}%`));
    });
  }

  function initShots() {
    $$('[data-shots]').forEach((sec) => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      const dialog = $('[data-shot-dialog]', sec);
      const holder = $('[data-shot-img]', sec);
      let img = null;
      $$('[data-shot]', sec).forEach((btn) => btn.addEventListener('click', () => {
        if (!img) { img = document.createElement('img'); holder.append(img); }
        img.alt = $('img', btn)?.alt || '';
        img.src = btn.dataset.shot;
        dialog.showModal();
      }));
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    });
  }

  function initCart() {
    const form = $('[data-cart-form]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    const error = $('[data-cart-error]');
    // Change lines by their unique key, not their position: with Buy X Get Y offers Shopify splits
    // the same product across lines, so positions shift and "remove line 2" can hit the wrong line.
    const change = async (key, quantity, el) => {
      el?.classList.add('is-loading');
      if (error) error.hidden = true;
      try {
        const res = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.description || data.message || 'Could not update your cart. Please try again.');
        window.location.reload();
      } catch (e) {
        el?.classList.remove('is-loading');
        if (error) { error.textContent = e.message; error.hidden = false; error.scrollIntoView({ block: 'center' }); }
      }
    };
    $$('[data-cart-remove]', form).forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      change(a.dataset.lineKey, 0, a);
    }));
    $$('[data-cart-qty]', form).forEach((q) => q.addEventListener('change', () => {
      const qty = Math.max(0, parseInt(q.value, 10) || 0);
      change(q.dataset.lineKey, qty, q);
    }));
  }

  function initMenu() {
    const d = $('[data-menu-drawer]');
    if (!d) return;
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') d.removeAttribute('open'); });
    d.addEventListener('click', (e) => { if (e.target === $('summary', d) && d.open) { e.preventDefault(); d.removeAttribute('open'); } });
  }

  function initProductSections(scope = document) {
    $$('[data-product-section]', scope).forEach((s) => {
      if (s.dataset.ready) return;
      s.dataset.ready = '1';
      initGallery(s); initOffers(s); initBuy(s); initSticky(s); initCountdown(s); initDelivery(s);
    });
  }

  function initAll() {
    initRotators(); initProductSections(); initReels(); initReviews(); initBeforeAfter(); initShots(); initJudgemePaging(); initBuyLinks(); initCart(); initMenu();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', () => { initRotators(); initProductSections(); initReviews(); initBeforeAfter(); initShots(); });
})();
